import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
    formataTableCellBodyExibeDadosSubTotalValor,
    formataTableCellBodyExibeDadosTotalValor,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridItem4,
    GridItem9,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEstudo,
} from '../../../business-components/Card/Card'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import {
    grupoCoberturaSeguroVidaList
 } from '../../../business-rules/List/SeguroVida/grupoCoberturaSeguroVidaList'

import tipoCoberturaSeguroVidaList from '../../../business-rules/List/SeguroVida/tipoCoberturaSeguroVidaList'

import {
    dadosCompletosLinhaSeguroVidaApolice,
} from '../seguroVida-form/SeguroVidaServiceSeguroVidaApolice'

import {
    dadosCompletosLinhaSeguroVidaCobertura,
} from '../seguroVida-form/SeguroVidaServiceSeguroVidaCobertura'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'



const EstudoFormResumoSeguroVidaCotacao = ( { values, estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras,
    utilizarApenasComparacaoPreco, report } ) => {

    const ResumoSeguroVidaCotacao = () => {

        const aumentoLetraCabecalho = 4
        const aumentoLetraReportCabecalho = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 4 : 6
        
        const aumentoLetra = 4
        const aumentoLetraReport = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 4 : 6

        let headList = [
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTexto('', report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.cobertura, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.capitalSegurado, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.premio, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
        ]

        const incluiCotacao = (cotacao) => {

            return (
                (
                    cotacao.utilizarApenasComparacaoPreco && utilizarApenasComparacaoPreco
                ) ||
                (
                    !cotacao.utilizarApenasComparacaoPreco && !utilizarApenasComparacaoPreco
                )
            ) &&
            cotacao.seguradora === estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras.id
        }

        const incluiItemCotacao = (cotacao, item) => {

            return item.idSeguroVidaCotacao === cotacao.id &&
                dadosCompletosLinhaSeguroVidaApolice(cotacao) &&
                dadosCompletosLinhaSeguroVidaCobertura(item, true)
        }

        let count = 0
        //let totalValorCS = 0
        let totalValorPremio = 0

        let totalValorPremioCliente = 0

        let contCobertura



        return (
            <>
                <GridContainer
                    className='mb-2'
                >
                    <GridItem4
                        className='ml--8'
                    >
                        {estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras.SvgLogoInstituicaoFinanceira && (
                            <estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras.SvgLogoInstituicaoFinanceira />
                        )}
                    </GridItem4>
                </GridContainer>

                <TableExibeDados
                    report={report}
                    noMinW={true}
                >
                    <TableHeadExibeDados
                        report={report}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    
                    {values.seguroVidaCotacao?.map((cotacao, indCotacao) => {
                        
                        count += incluiCotacao(cotacao) ? 1 : 0

                        totalValorPremioCliente = 0

                        contCobertura = 0

                        return incluiCotacao(cotacao) && (
                            <TableBodyExibeDados
                                key={indCotacao}
                            >
                                {values.seguroVidaCotacaoCobertura?.map((item, ind) => {

                                    //totalValorCS += incluiItemCotacao(cotacao, item) ? round(item.valorCS, 2) : 0
                                    totalValorPremio += incluiItemCotacao(cotacao, item) ? round(item.valorPremio, 2) : 0

                                    totalValorPremioCliente +=
                                        incluiItemCotacao(cotacao, item) ? round(item.valorPremio, 2) : 0

                                    contCobertura += incluiItemCotacao(cotacao, item) ? 1 : 0
                                    
                                    return (incluiItemCotacao(cotacao, item)) && (
                                        <>
                                            {contCobertura === 1 && (
                                                <h6
                                                    className='mt-8'
                                                >
                                                    {pesquisaDescricaoList(familiaresList(values), cotacao.familiar)}
                                                </h6>
                                            )}

                                            <TableRowBodyExibeDados
                                                key={ind}
                                                report={report}
                                            >
                                                <TableCellBodyExibeDados
                                                    colSpan={headList[0].colSpan}
                                                    primeiraColuna={true}
                                                >
                                                    {''}
                                                </TableCellBodyExibeDados>

                                                <TableCellBodyExibeDados
                                                    colSpan={headList[1].colSpan}
                                                >
                                                    {formataTableCellBodyExibeDadosTexto(
                                                        pesquisaDescricaoList(grupoCoberturaSeguroVidaList, item.grupoCoberturaSeguroVida) + ' - ' +
                                                            pesquisaDescricaoList(tipoCoberturaSeguroVidaList, item.tipoCoberturaSeguroVida),
                                                                report, false, aumentoLetra, aumentoLetraReport, values)
                                                    }
                                                </TableCellBodyExibeDados>
                                                
                                                <TableCellBodyExibeDados
                                                    colSpan={headList[2].colSpan}
                                                >
                                                    {formataTableCellBodyExibeDadosValor(round(item.valorCS, 2),
                                                        report, false, false, aumentoLetra, aumentoLetraReport, values)
                                                    }
                                                </TableCellBodyExibeDados>

                                                <TableCellBodyExibeDados
                                                    colSpan={headList[3].colSpan}
                                                >
                                                    {formataTableCellBodyExibeDadosValor(round(item.valorPremio, 2),
                                                        report, false, false, aumentoLetra, aumentoLetraReport, values)
                                                    }
                                                </TableCellBodyExibeDados>
                                            </TableRowBodyExibeDados>
                                        </>
                                    )
                                })}

                                <TableRowBodyExibeDados
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[0].colSpan}
                                        primeiraColuna={true}
                                    >
                                        {''}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[1].colSpan}
                                    >
                                        {''}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[2].colSpan}
                                    >
                                        {/*formataTableCellBodyExibeDadosSubTotalValor(totalValorCS, report,
                                            aumentoLetra, aumentoLetraReport, values)*/}
                                        {''}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[3].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosSubTotalValor(totalValorPremioCliente, report,
                                            false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>
                                </TableRowBodyExibeDados>
                            </TableBodyExibeDados>
                        )
                    })}

                    {count > 1 && (
                        <TableBodyExibeDados>
                            <div
                                className='mt-5'
                            />
                            
                            <TableRowBodyExibeDados
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[0].colSpan}
                                    primeiraColuna={true}
                                >
                                    {''}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[1].colSpan}
                                >
                                    {''}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[2].colSpan}
                                >
                                    {/*formataTableCellBodyExibeDadosTotalValor(totalValorCS, report, false,
                                        aumentoLetra, aumentoLetraReport, values)*/}
                                    {''}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[3].colSpan}
                                >
                                    {formataTableCellBodyExibeDadosTotalValor(totalValorPremio, report, false,
                                        aumentoLetra, aumentoLetraReport, values)}
                                </TableCellBodyExibeDados>
                            </TableRowBodyExibeDados>
                        </TableBodyExibeDados>
                    )}
                </TableExibeDados>
            </>
        )
    }

    return (
        report || relatorioModoApresentacao(values)
            ?
                //<div
                //    className={(!report && relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                //>
                    <ResumoSeguroVidaCotacao/>
                //</div>
            :
                <GridContainer
                    className='justify-center'
                >
                    <GridItem9>
                        <CardGridEstudo>
                            <CardGridEstudoTabelaPadrao
                                values={values}
                                SvgIcon={""}
                                label={LABEL.resumoCotacao + ': ' +
                                    estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras.descricao
                                }
                                helpTextMorte={""}
                                helpTextInvalidez={""}
                                component={<ResumoSeguroVidaCotacao/>}
                                popup={false}
                            />
                        </CardGridEstudo>
                    </GridItem9>
                </GridContainer>
    )
}

export default EstudoFormResumoSeguroVidaCotacao